import { omit } from 'lodash';
import { createAction } from 'redux-actions';

import { ADD_RE_EXECUTION, GET_RE_EXECUTIONS } from './constants';

export const getReExecutions = createAction(GET_RE_EXECUTIONS.REQUEST, params => omit(params, 'type'));

export const addReExecution = createAction(ADD_RE_EXECUTION.REQUEST);
